import createSDK, {SDK} from '@gs-yoga/sdk'
import {getCookie} from "vinxi/http";
import {isServer} from "solid-js/web";

function createServerSDK() {
    "use server"
    const token = getCookie("session_token")
    const headers = token
        ? {Cookie: `session_token=${token}`}
        : undefined;
    return createSDK({
        prefixUrl: process.env.API_HOST,
        headers: headers
    })
}

let clientSDK: SDK | undefined

export default function sdk(): SDK {
    if (isServer) {
        return createServerSDK()
    } else {
        if (!clientSDK) {
            clientSDK = createSDK({
                prefixUrl: window.__ENV__.API_HOST,
                credentials: "include"
            })
        }
        return clientSDK
    }
}
